import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, InputLabel, FormControlLabel, Radio
} from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import { RadioGroup } from 'formik-material-ui';
import { DateFormik } from 'components/Shared/CustomInputs';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { TimePicker } from 'formik-material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ReportScheduleIntervals } from 'enums';
import { useStyles } from 'components/Reports';
import Schema from 'schemas/ReportScheduler.schema';
import { buildYupSchema } from 'utils/SchemaUtils';
import moment from 'moment';
import { NotificationsSnackBar } from 'components/Shared/DynamicForm';
import { scheduleReport } from 'utils/ReportUtils';

const refreshLagTime = 2000;

const SchedulerDialog = ({ open, close, formValues, inputVariant, resetForm, selectedProject, systemUserId }) => {
    const classes = useStyles();

    const validation = buildYupSchema(Schema);

    const start = moment();
    const remainder = 30 - (start.minute() % 30);
    const dateTime = moment(start).add(remainder, "minutes");

    return (
        <Dialog open={open} onClose={close}>
            <DialogTitle>Schedule Task</DialogTitle>
            <Formik
                initialValues={{
                    TimeofDay: new Date(dateTime),
                    StartDate: new Date(),
                    EndDate: null,
                    Interval: "Daily"
                }}
                validationSchema={validation}
                onSubmit={async (values, { setSubmitting, setStatus }) => {
                    const editResult = await scheduleReport(values, selectedProject, systemUserId);
                        if (editResult.success) {
                            setStatus({ success: false, message: "Form was submitted successfully", alertType: "success" });
                            await new Promise(resolve => setTimeout(resolve, refreshLagTime));
                        } else {
                            setStatus({ success: false, message: "There was an issue submitting the form", alertType: "error" });
                            await new Promise(resolve => setTimeout(resolve, refreshLagTime));
                        };

                        setSubmitting(false)
                }}
            >
                {({ values, isSubmitting, status, setStatus }) => (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Form>
                            <DialogContent className={classes.dialogContent}>
                                <Grid container spacing={4} className={classes.generatorForm}>
                                    <Grid item lg={4} md={4} sm={12}>
                                        <InputLabel htmlFor="TimeofDay">Time of Day</InputLabel>
                                        <Field
                                            style={{ width: "100%" }}
                                            name="TimeofDay"
                                            variant={inputVariant}
                                            component={TimePicker}
                                            minutesStep={30}
                                            clearable={true}
                                            inputProps={{
                                                id: "TimeofDay"
                                            }}
                                        >
                                        </Field>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={12}>
                                        <InputLabel htmlFor="StartDate">Start Date</InputLabel>
                                        <Field
                                            style={{ width: "100%" }}
                                            name="StartDate"
                                            variant={inputVariant}
                                            component={DateFormik}
                                            inputProps={{
                                                id: "StartDate"
                                            }}
                                            format="MM/dd/yyyy"
                                            clearable
                                        >
                                        </Field>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={12}>
                                        <InputLabel htmlFor="EndDate">End Date</InputLabel>
                                        <Field
                                            name="EndDate"
                                            variant={inputVariant}
                                            component={DateFormik}
                                            inputProps={{
                                                id: "EndDate"
                                            }}
                                            format="MM/dd/yyyy"
                                            clearable
                                        >
                                        </Field>
                                    </Grid>
                                    <Grid item sm={12} xs={12} md={12} lg={12} xl={12}>
                                        <InputLabel htmlFor="Interval">Select Run Interval</InputLabel>
                                        <Field component={RadioGroup} name="Interval">
                                            {
                                                Object.entries(ReportScheduleIntervals).map(([value, description]) => (
                                                    <FormControlLabel
                                                        value={value}
                                                        control={<Radio disabled={isSubmitting} />}
                                                        label={description}
                                                        disabled={isSubmitting}
                                                        key={value}
                                                    />
                                                ))
                                            }
                                        </Field>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={close} color="primary">
                                    Cancel
                          </Button>
                                <Button type="submit" color="primary">
                                    Set
                          </Button>
                            </DialogActions>
                            <NotificationsSnackBar status={status} setStatus={setStatus} refreshLagTime={refreshLagTime} />
                        </Form>
                    </MuiPickersUtilsProvider>
                )}
            </Formik>
        </Dialog>
    )
};

export default SchedulerDialog;